export default __webpack_public_path__ + "static/images/0ff8b471.png";